import { DsLibMainMenuSectionInterface } from '@sixense/ds-lib-main-menu';
import { DS_DIRECTORY_MENU } from './menu-sections/ds-directory-menu.constant';
import { DS_DOCS_MENU } from './menu-sections/ds-docs-menu.constant';
import { DS_DOCUMENTATION_MENU } from './menu-sections/ds-documentation-menu.constant';
import { DS_FORMS_MENU } from './menu-sections/ds-forms-menu.constant';
import { DS_HOME_MENU } from './menu-sections/ds-home-menu.constant';
import { DS_PINS_MENU } from './menu-sections/ds-pins-menu.constant';
import { DS_SYNOPTICS_MENU } from './menu-sections/ds-synoptics-menu.constant';
import { DS_SETTINGS_MENU } from './menu-sections/ds-settings-menu.constant';

export const MENU_SECTIONS: DsLibMainMenuSectionInterface[] = [
  DS_HOME_MENU,
  DS_PINS_MENU,
  DS_FORMS_MENU,
  DS_DOCS_MENU,
  DS_DIRECTORY_MENU,
  DS_SYNOPTICS_MENU,
  DS_SETTINGS_MENU,
  DS_DOCUMENTATION_MENU,
];
